/**
 * Число активных заказов владельца для бейджа в меню.
 * Один запрос на все меню страницы; повторный вызов во время запроса ждёт его же.
 */
let pendingCount: Promise<void> | null = null

export function useOwnerActiveOrderCount() {
  const shopEnabled = isShopEnabled()
  const count = useState<number | null>('ownerActiveShopOrderCount', () => null)
  const auth = useAuthStore()
  const {apiQuery} = useApi()

  const refresh = (): Promise<void> => {
    if (!shopEnabled || auth.userRole !== 'client') {
      count.value = null
      return Promise.resolve()
    }

    if (pendingCount) return pendingCount

    pendingCount = apiQuery<{count: number}>('/client/shop/orders/active-count/', 'GET')
      .then((data) => {
        count.value = data.count
      })
      .catch(() => {
        count.value = null
      })
      .finally(() => {
        pendingCount = null
      })

    return pendingCount
  }

  return {count, refresh}
}
